import { __decorate, __metadata } from "tslib";
import { provide } from '@/inversify.config';
export const HighlightServiceSymbol = Symbol('HighlightService');
let HighlightService = class HighlightService {
    constructor() {
        this._isLoadingBackendKeywords = false;
        this._config = null;
        this._backendKeywords = [];
        this._cache = {};
        this.visible = false;
        this.positionRight = null;
        this._isLoadingBackendKeywords = false;
        this._config = null;
        this._backendKeywords = [];
        this._cache = {};
        this.visible = false;
        this.positionRight = null;
    }
    set config(config) {
        this._config = config;
        window.Bus.$emit('SpaceDetail:Highlight:updateSetting', { backendKeywordsQuery: true });
    }
    get config() {
        return this._config;
    }
    set isLoadingBackendKeywords(isLoadingBackendKeywords) {
        this._isLoadingBackendKeywords = isLoadingBackendKeywords;
        isLoadingBackendKeywords && this.clearHighlightTextCache();
        window.Bus.$emit('SpaceDetail:Highlight:Loading');
    }
    get isLoadingBackendKeywords() {
        return this._isLoadingBackendKeywords;
    }
    set backendKeywords(backendKeywords) {
        this._backendKeywords = backendKeywords;
        window.Bus.$emit('SpaceDetail:Highlight:updateSetting', { backendKeywords: true });
    }
    get backendKeywords() {
        return this._backendKeywords;
    }
    getBackendKeywordsQuery() {
        const { qid = '', folderId = '', stem = false } = this.config || {};
        return `_${folderId}_${qid}&&stemStatus=${stem}`;
    }
    getCacheHighlightText(key) {
        // eslint-disable-next-line
        if (this._cache.hasOwnProperty(key)) {
            return this._cache[key];
        }
        return false;
    }
    setHighlightTextCache(key, value) {
        this._cache[key] = value;
        return value;
    }
    clearHighlightTextCache() {
        this._cache = {};
    }
};
HighlightService = __decorate([
    provide(HighlightServiceSymbol),
    __metadata("design:paramtypes", [])
], HighlightService);
export { HighlightService };
